import React from 'react';
import { Link } from "react-router-dom";

import ClientHeader from "../../client-header/components/index";
import ClientFooter from "../../client-footer/components/index";

import FundraisingHeader from "../layout/header";
import FundraisingFooter from '../layout/footer';

const CorporatePartners = () => {
    // Top Hero Features
    const heroFeatures = [
        {
            title: 'Corporate Sponsorships',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11" />
                </svg>
            )
        },
        {
            title: 'Employee Engagement',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
            )
        },
        {
            title: 'Cause Marketing',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
            )
        },
        {
            title: 'Community Impact',
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
            )
        },
    ];

    return (
        <>
            <FundraisingHeader />
            <main className="overflow-hidden">

                {/* ================= HERO SECTION (Asymmetrical Floating Grid) ================= */}
                {/* ================= HERO SECTION (Asymmetrical Floating Grid) ================= */}
                <section className="position-relative py-5" style={{ background: '#fdfaf4', paddingTop: '6rem', paddingBottom: '6rem' }}>

                    {/* Background Abstract Shapes */}
                    <div className="position-absolute top-0 end-0 w-50 h-100" style={{ background: 'radial-gradient(circle at 80% 20%, rgba(251,191,36,0.1) 0%, transparent 60%)', zIndex: 0 }}></div>

                    <div className="container position-relative" style={{ zIndex: 2 }}>
                        <div className="row align-items-center g-0">

                            {/* Left Side: Massive Editorial Typography (Made slightly narrower to give image more room) */}
                            <div className="col-lg-5 pe-lg-5 mb-5 mb-lg-0">
                                <span
                                    className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-4"
                                    style={{ background: 'rgba(30,41,59,0.05)', color: '#1e293b', padding: '0.4rem 1rem', fontSize: '0.75rem', letterSpacing: '0.1em', textTransform: 'uppercase', border: '1px solid rgba(30,41,59,0.1)' }}
                                >
                                    <span className="d-inline-block rounded-circle" style={{ width: 8, height: 8, background: '#d97706' }}></span>
                                    Corporate Partnerships
                                </span>

                                <h1
                                    className="fw-bold mb-4"
                                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2.8rem, 4vw, 4.5rem)', lineHeight: 1.05, color: '#0f172a', letterSpacing: '-0.02em' }}
                                >
                                    Partner for a <br />
                                    <span style={{ color: '#d97706', fontStyle: 'italic' }}>Stronger</span> <br />
                                    Tomorrow.
                                </h1>

                                <p className="lh-lg mb-5" style={{ color: '#4b5563', fontSize: '1.1rem', maxWidth: '440px', fontWeight: 500 }}>
                                    Join us as a corporate partner and help expand inclusive early childhood education and special needs services in our community.
                                </p>

                                <div className="d-flex align-items-center gap-4">
                                    <Link to="/campaign-contact" className="text-decoration-none">
                                        <button
                                            className="btn fw-bold rounded-pill px-4 py-3 border-0 d-inline-flex align-items-center gap-2"
                                            style={{ background: '#1e293b', color: '#ffffff', fontSize: '1.05rem', boxShadow: '0 15px 30px -10px rgba(30,41,59,0.4)', transition: 'transform 0.2s ease' }}
                                            onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-3px)')}
                                            onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                                        >
                                            Become a Partner
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12l-7.5 7.5M21 12H3" />
                                            </svg>
                                        </button>
                                    </Link>
                                </div>
                            </div>

                            {/* Right Side: Overlapping Image with Floating Badge (Made wider for larger image) */}
                            <div className="col-lg-7 position-relative">
                                <div className="position-relative mx-auto" style={{ maxWidth: '750px' }}>

                                    {/* Amber Accent Blob Behind Image */}
                                    <div
                                        className="position-absolute"
                                        style={{
                                            inset: -25,
                                            background: 'linear-gradient(135deg, #fbbf24 0%, #f97316 100%)',
                                            borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
                                            zIndex: 0,
                                            transform: 'rotate(-4deg)',
                                            opacity: 0.15
                                        }}
                                    ></div>

                                    {/* Main Image - Stretched larger */}
                                    <img
                                        src="/assets/images/fundraising/01_corporate_partnership_hero.png"
                                        alt="Corporate partners shaking hands"
                                        className="position-relative img-fluid shadow-lg"
                                        style={{
                                            borderRadius: '48px', // Slightly larger radius for the bigger image
                                            zIndex: 1,
                                            width: '100%',
                                            aspectRatio: '4/3', // Maintains a good landscape shape
                                            objectFit: 'cover'
                                        }}
                                    />

                                    {/* Floating Glass Feature Card Overlapping the Image */}
                                    <div
                                        className="position-absolute bg-white rounded-4 shadow-lg p-4"
                                        style={{
                                            bottom: '-40px',
                                            left: '-40px',
                                            width: '115%',
                                            maxWidth: '520px', // Made the card slightly wider to match the bigger image
                                            zIndex: 2,
                                            border: '1px solid rgba(0,0,0,0.05)'
                                        }}
                                    >
                                        <div className="row g-3">
                                            {heroFeatures.map((feature, idx) => (
                                                <div className="col-6 d-flex align-items-center gap-3" key={idx}>
                                                    <div
                                                        className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                                                        style={{ width: 44, height: 44, background: 'rgba(251,191,36,0.15)', color: '#d97706' }}
                                                    >
                                                        <div style={{ transform: 'scale(0.85)' }}>{feature.icon}</div>
                                                    </div>
                                                    <p className="fw-bold mb-0 lh-sm" style={{ color: '#1e293b', fontSize: '0.9rem' }}>
                                                        {feature.title}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                {/* ================= STRATEGIC COLLABORATION (Dark Immersive Section) ================= */}
                <section className="py-5 position-relative overflow-hidden" style={{ background: '#0f172a', paddingTop: '8rem', paddingBottom: '8rem', marginTop: '4rem' }}>

                    {/* Glow Accents */}
                    <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'radial-gradient(circle at 10% 90%, rgba(251,191,36,0.1) 0%, transparent 50%)' }}></div>

                    <div className="container position-relative" style={{ zIndex: 2 }}>
                        <div className="row align-items-center g-5">

                            {/* Left Column: Text Content */}
                            <div className="col-lg-6 order-2 order-lg-1">
                                <h2
                                    className="fw-bold mb-4 text-white"
                                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2rem, 3.5vw, 3rem)', lineHeight: 1.15 }}
                                >
                                    Strategic <span style={{ color: '#fbbf24' }}>Collaboration</span>
                                </h2>

                                <p className="lh-lg mb-5" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '1.05rem' }}>
                                    We collaborate with organizations that share our vision for growth, innovation, and long-term success. Our partnerships bring together expertise, resources, and ideas to create meaningful business opportunities.
                                </p>

                                <div className="d-flex flex-column gap-4">
                                    {/* Feature 1 */}
                                    <div className="d-flex gap-4 align-items-start">
                                        <div className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0" style={{ width: 48, height: 48, background: 'rgba(255,255,255,0.1)', color: '#fbbf24' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold text-white mb-2">Mutual Growth Opportunities</h5>
                                            <p className="mb-0" style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.95rem' }}>
                                                We believe strong partnerships are built on shared goals and mutual benefits. Through collaboration, we help our partners expand their reach and strengthen their networks.
                                            </p>
                                        </div>
                                    </div>

                                    {/* Feature 2 */}
                                    <div className="d-flex gap-4 align-items-start">
                                        <div className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0" style={{ width: 48, height: 48, background: 'rgba(255,255,255,0.1)', color: '#fbbf24' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h5 className="fw-bold text-white mb-2">Long-Term Relationships</h5>
                                            <p className="mb-0" style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.95rem' }}>
                                                Our approach focuses on building trusted relationships with businesses across different industries, valuing transparency, reliability, and a shared commitment.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right Column: Image inside a glass frame */}
                            <div className="col-lg-6 order-1 order-lg-2">
                                <div className="position-relative ms-lg-4">
                                    <div
                                        className="position-absolute w-100 h-100 rounded-4"
                                        style={{ background: 'linear-gradient(135deg, rgba(251,191,36,0.3), transparent)', top: 20, left: 20, zIndex: 0 }}
                                    ></div>
                                    <img
                                        src="/assets/images/about-img.jpg"
                                        alt="Collaboration"
                                        className="position-relative img-fluid rounded-4 w-100"
                                        style={{ zIndex: 1, aspectRatio: '4/3', objectFit: 'cover', border: '1px solid rgba(255,255,255,0.1)' }}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

                               {/* ================= WHY PARTNER WITH US (4 Cards) ================= */}
                <section className="py-5" style={{ background: '#fdfaf4', paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row justify-content-center text-center mb-5">
                            <div className="col-lg-8">
                                <span
                                    className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-3"
                                    style={{ background: 'rgba(251,191,36,0.12)', color: '#b45309', padding: '0.4rem 0.9rem', fontSize: '0.72rem', letterSpacing: '0.1em', textTransform: 'uppercase', border: '1px solid rgba(251,191,36,0.35)' }}
                                >
                                    <span className="d-inline-block rounded-circle" style={{ width: 6, height: 6, background: '#f59e0b' }}></span>
                                    Partnership Benefits
                                </span>
                                <h2
                                    className="fw-bold mb-3"
                                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2rem, 3.5vw, 2.75rem)', color: '#0f172a' }}
                                >
                                    Why Partner With <span style={{ color: '#d97706' }}>Us</span>
                                </h2>
                                <p className="mx-auto" style={{ color: '#4b5563', maxWidth: '600px', fontSize: '1.05rem' }}>
                                    Discover how your organization can align with our mission to create lasting change while achieving your business goals.
                                </p>
                            </div>
                        </div>

                        <div className="row g-4 justify-content-center">

                            {/* Card 1: Corporate Sponsorships */}
                            <div className="col-lg-3 col-md-6">
                                <div 
                                    className="card h-100 border-0 rounded-4 p-4 shadow-sm" 
                                    style={{ 
                                        background: '#ffffff', 
                                        borderTop: '4px solid #fbbf24 !important',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.03)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                                        e.currentTarget.style.background = '#1e293b';
                                        e.currentTarget.querySelector('h4').style.color = '#ffffff';
                                        e.currentTarget.querySelector('p').style.color = 'rgba(255,255,255,0.7)';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(255,255,255,0.1)';
                                        iconWrap.style.color = '#fbbf24';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                                        e.currentTarget.style.background = '#ffffff';
                                        e.currentTarget.querySelector('h4').style.color = '#1e293b';
                                        e.currentTarget.querySelector('p').style.color = '#4b5563';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(251,191,36,0.15)';
                                        iconWrap.style.color = '#d97706';
                                    }}
                                >
                                    <div 
                                        className="icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                                        style={{ width: 56, height: 56, background: 'rgba(251,191,36,0.15)', color: '#d97706', transition: 'all 0.3s ease' }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11" />
                                        </svg>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ color: '#1e293b', fontFamily: '"Playfair Display", serif', fontSize: '1.2rem', transition: 'color 0.3s ease' }}>Corporate Sponsorships</h4>
                                    <p className="lh-lg mb-0" style={{ color: '#4b5563', fontSize: '0.95rem', transition: 'color 0.3s ease' }}>
                                        Gain prominent brand visibility across our programs and events. Align your company with a trusted cause that resonates with your customers and employees.
                                    </p>
                                </div>
                            </div>

                            {/* Card 2: Employee Engagement */}
                            <div className="col-lg-3 col-md-6">
                                <div 
                                    className="card h-100 border-0 rounded-4 p-4 shadow-sm" 
                                    style={{ 
                                        background: '#ffffff', 
                                        borderTop: '4px solid #fbbf24 !important',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.03)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                                        e.currentTarget.style.background = '#1e293b';
                                        e.currentTarget.querySelector('h4').style.color = '#ffffff';
                                        e.currentTarget.querySelector('p').style.color = 'rgba(255,255,255,0.7)';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(255,255,255,0.1)';
                                        iconWrap.style.color = '#fbbf24';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                                        e.currentTarget.style.background = '#ffffff';
                                        e.currentTarget.querySelector('h4').style.color = '#1e293b';
                                        e.currentTarget.querySelector('p').style.color = '#4b5563';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(251,191,36,0.15)';
                                        iconWrap.style.color = '#d97706';
                                    }}
                                >
                                    <div 
                                        className="icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                                        style={{ width: 56, height: 56, background: 'rgba(251,191,36,0.15)', color: '#d97706', transition: 'all 0.3s ease' }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                                        </svg>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ color: '#1e293b', fontFamily: '"Playfair Display", serif', fontSize: '1.2rem', transition: 'color 0.3s ease' }}>Employee Engagement</h4>
                                    <p className="lh-lg mb-0" style={{ color: '#4b5563', fontSize: '0.95rem', transition: 'color 0.3s ease' }}>
                                        Boost team morale and foster a culture of giving through volunteer opportunities. Provide your staff with meaningful ways to connect with the community.
                                    </p>
                                </div>
                            </div>

                            {/* Card 3: Cause Marketing */}
                            <div className="col-lg-3 col-md-6">
                                <div 
                                    className="card h-100 border-0 rounded-4 p-4 shadow-sm" 
                                    style={{ 
                                        background: '#ffffff', 
                                        borderTop: '4px solid #fbbf24 !important',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.03)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                                        e.currentTarget.style.background = '#1e293b';
                                        e.currentTarget.querySelector('h4').style.color = '#ffffff';
                                        e.currentTarget.querySelector('p').style.color = 'rgba(255,255,255,0.7)';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(255,255,255,0.1)';
                                        iconWrap.style.color = '#fbbf24';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                                        e.currentTarget.style.background = '#ffffff';
                                        e.currentTarget.querySelector('h4').style.color = '#1e293b';
                                        e.currentTarget.querySelector('p').style.color = '#4b5563';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(251,191,36,0.15)';
                                        iconWrap.style.color = '#d97706';
                                    }}
                                >
                                    <div 
                                        className="icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                                        style={{ width: 56, height: 56, background: 'rgba(251,191,36,0.15)', color: '#d97706', transition: 'all 0.3s ease' }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                        </svg>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ color: '#1e293b', fontFamily: '"Playfair Display", serif', fontSize: '1.2rem', transition: 'color 0.3s ease' }}>Cause Marketing</h4>
                                    <p className="lh-lg mb-0" style={{ color: '#4b5563', fontSize: '0.95rem', transition: 'color 0.3s ease' }}>
                                        Collaborate on targeted campaigns that drive sales and awareness. Show your customers that your brand cares about creating a brighter future for children.
                                    </p>
                                </div>
                            </div>

                            {/* Card 4: Community Impact */}
                            <div className="col-lg-3 col-md-6">
                                <div 
                                    className="card h-100 border-0 rounded-4 p-4 shadow-sm" 
                                    style={{ 
                                        background: '#ffffff', 
                                        borderTop: '4px solid #fbbf24 !important',
                                        transition: 'all 0.3s ease',
                                        cursor: 'pointer'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = 'scale(1.03)';
                                        e.currentTarget.style.boxShadow = '0 20px 40px -10px rgba(15,23,42,0.2)';
                                        e.currentTarget.style.background = '#1e293b';
                                        e.currentTarget.querySelector('h4').style.color = '#ffffff';
                                        e.currentTarget.querySelector('p').style.color = 'rgba(255,255,255,0.7)';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(255,255,255,0.1)';
                                        iconWrap.style.color = '#fbbf24';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'scale(1)';
                                        e.currentTarget.style.boxShadow = '0 .125rem .25rem rgba(0,0,0,.075)';
                                        e.currentTarget.style.background = '#ffffff';
                                        e.currentTarget.querySelector('h4').style.color = '#1e293b';
                                        e.currentTarget.querySelector('p').style.color = '#4b5563';
                                        const iconWrap = e.currentTarget.querySelector('.icon-wrapper');
                                        iconWrap.style.background = 'rgba(251,191,36,0.15)';
                                        iconWrap.style.color = '#d97706';
                                    }}
                                >
                                    <div 
                                        className="icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle mb-4" 
                                        style={{ width: 56, height: 56, background: 'rgba(251,191,36,0.15)', color: '#d97706', transition: 'all 0.3s ease' }}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                                        </svg>
                                    </div>
                                    <h4 className="fw-bold mb-3" style={{ color: '#1e293b', fontFamily: '"Playfair Display", serif', fontSize: '1.2rem', transition: 'color 0.3s ease' }}>Community Impact</h4>
                                    <p className="lh-lg mb-0" style={{ color: '#4b5563', fontSize: '0.95rem', transition: 'color 0.3s ease' }}>
                                        Make a measurable difference in the local community. We provide transparent reporting so you can see exactly how your partnership changes lives.
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>

            </main>
            <FundraisingFooter />
        </>
    );
};

export default CorporatePartners;